(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-description')) {
    customElements.define(
      'collection-description',
      class CollectionDescription extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('[ref="content"]');
          this.toggle = this.querySelector('[ref="toggle"]');
          this.label = this.querySelector('[ref="label"]');

          // No toggle rendered means read-more is disabled — nothing to do.
          if (!this.content || !this.toggle) return;

          this.moreLabel = this.dataset.moreLabel || 'Read more';
          this.lessLabel = this.dataset.lessLabel || 'Read less';
          this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 240;

          this.onToggle = this.onToggle.bind(this);
          requestAnimationFrame(() => this.setup());
        }

        setup() {
          // Only collapse when the content is taller than the collapsed height,
          // otherwise leave it fully expanded and keep the button hidden.
          if (this.content.scrollHeight <= this.collapsedHeight + 8) return;

          this.content.dataset.collapsed = 'true';
          this.toggle.hidden = false;
          this.toggle.setAttribute('aria-expanded', 'false');
          if (this.label) this.label.textContent = this.moreLabel;
          this.toggle.addEventListener('click', this.onToggle);
        }

        onToggle() {
          const isCollapsed = this.content.dataset.collapsed === 'true';
          this.content.dataset.collapsed = isCollapsed ? 'false' : 'true';
          this.toggle.setAttribute('aria-expanded', String(isCollapsed));
          if (this.label) this.label.textContent = isCollapsed ? this.lessLabel : this.moreLabel;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-partner-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('.cp-hero__actions .cp-btn--primary[data-cp-scroll-target]')
      : null;

    if (!trigger) {
      return;
    }

    const target = document.getElementById(trigger.dataset.cpScrollTarget);

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
